import CoreValues from "../../components/User/About/CoreValues";
import CTASection from "../../components/User/About/CTASection";
import HeroSection from "../../components/User/About/HeroSection";
import Partnerships from "../../components/User/About/Partnerships";
import ServicesSection from "../../components/User/About/ServicesSection";
import Technology from "../../components/User/About/Technology";
import WhoWeAre from "../../components/User/About/WhoWeAre";
import WhyChooseUs from "../../components/User/About/WhyChooseUs";
import ReviewCarousel from "../../components/User/Common/ReviewCarousel";
export default function About() {
  return (
    <div className="w-full font-body overflow-x-hidden">
      <HeroSection />
      <WhoWeAre />
      <CoreValues />
      <WhyChooseUs />
      <Technology />
      <ServicesSection />
      <Partnerships />
      <CTASection />
       <ReviewCarousel/>
    </div>
  );
}
